export default __webpack_public_path__ + "static/box-usage-example-1c2ea8d1a1621cd71694279d7a91b991.png";